import styled from "styled-components";

const BaseButton = styled.button`
  border-radius: 4px;
  padding: 10px 24px;
  cursor: pointer;
  border: none;
  transition: all 0.1s ease-in-out;
  outline: none;
  ${({ theme }) => theme.mediaWidth.upToSmall`
        width: 100%;
    `}
  &:disabled {
    cursor: not-allowed;
    background-color: ${({ theme }) => theme.colors.neutral60};
    color: ${({ theme }) => theme.colors.neutral80};
  }
`;

export const PrimaryButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.colors.primary40};
  color: ${({ theme }) => theme.colors.neutral100};

  &:hover:enabled {
    background-color: ${({ theme }) => theme.colors.primary60};
  }
  &:active:enabled {
    background-color: ${({ theme }) => theme.colors.primary60};
  }
`;

export const SecondaryButton = styled(BaseButton)`
  background-color: ${({ theme }) => theme.colors.secondary00};
  color: ${({ theme }) => theme.colors.neutral00};
  &:hover:enabled {
    background-color: ${({ theme }) => theme.colors.secondary20};
  }
  &:active:enabled {
    background-color: ${({ theme }) => theme.colors.secondary20};
  }
`;
